import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { Table } from 'primeng/table';
import { OrderService } from 'src/app/core/services/order.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { ConfirmModalService } from 'src/app/core/services/confirm-modal.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrl: './orders.component.scss'
})
export class OrdersComponent {


  orders: any = [];
  loading = false;
  error = '';
  breadCrumbItems: Array<{}>;
  @ViewChild('dt') table!: Table;
  editForm!: FormGroup

  constructor(
  private orderService: OrderService,
  private toastService: ToastService,
  private fb: FormBuilder,
  private cdr: ChangeDetectorRef,
  private confirmModalService: ConfirmModalService
) {
  this.breadCrumbItems = [{ label: 'AVSS eSign' }, { label: 'Orders', active: true }];
}

  ngOnInit() {
    this.editForm = this.fb.group({
      amount: [''],
      documents: [''],
      users: [''],
      endDate: ['']
    });
  }


  loadOrders(event: LazyLoadEvent) {
    this.loading = true;
    this.cdr.detectChanges();
    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;
    let startDate: string | null = null;
    let endDate: string | null = null;

    if (this.rangeDates && this.rangeDates.length === 2) {
      startDate = this.formatDate(this.rangeDates[0]);
      endDate = this.formatDate(this.rangeDates[1]);
    }

    const queryParams = {
      page: page,
      limit: rows,
      search: this.searchText,
      orderId: this.orderId,
      status: this.selectedStatus,
      startDate: startDate,
      endDate: endDate
    };
    this.orderService.getOrders(queryParams).subscribe({
      next: (res: any) => {
        this.loading = false
        this.orders = res?.data || res;
        this.totalRecords = res?.totalCount || 0;
        this.cdr.detectChanges();
      },
      error: () => {
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  updateOrderStatus(order: any, status: 'Completed' | 'Cancelled') {
  const message =
    status === 'Completed'
      ? 'Are you sure you want to complete this order?'
      : 'Are you sure you want to cancel this order?';

  const title =
    status === 'Completed'
      ? 'Complete Order'
      : 'Cancel Order';

  const confirmButton =
    status === 'Completed'
      ? 'Complete'
      : 'Cancel Order';

  // Order detail modal hide hoga
  this.showModal = false;

  // Modal hide hone ke baad common confirm modal open hoga
  setTimeout(() => {
    this.confirmModalService.open(
      title,
      message,
      () => {
        this.confirmUpdateOrderStatus(order, status);
      },
      confirmButton,
      'Cancel'
    );
  }, 200);
}

confirmUpdateOrderStatus(order: any, status: 'Completed' | 'Cancelled') {
  if (status === 'Completed') {
    const data = {
      plan: order?.planName,
      endDate: this.editForm.value.endDate,
      amount: this.editForm.value.amount,
      users: this.editForm.value.users,
      documents: this.editForm.value.documents,
      status: 'Completed'
    };

    const payload =
      order?.planName === 'Enterprise'
        ? data
        : { status: 'Completed' };

    this.orderService.completeOrder(payload, this.orderdetail?._id).subscribe(
      () => {
        this.loadOrders({ first: 0, rows: this.rows });

        this.toastService.showToaster(
          'Update Order',
          'Order successfully completed!',
          'success'
        );
      },
      () => { }
    );
  } else {
    this.orderService.cancelOrder(this.orderdetail?._id).subscribe(
      () => {
        this.loadOrders({ first: 0, rows: this.rows });

        this.toastService.showToaster(
          'Update Order',
          'Order successfully cancelled!',
          'success'
        );
      },
      () => { }
    );
  }
}

  showModal: boolean = false;
  orderdetail: any = {};

  closeModal() {
    this.showModal = false
  }

  getOrderDetail(order: any) {
    this.orderService.getOrdersById(order?._id).subscribe(
      (res: any) => {
        this.orderdetail = res;

        this.editForm.patchValue({
          amount: res?.amount,
          documents: res?.documents,
          users: res?.users,
          endDate: res?.endDate
        });

        this.showModal = true;
      },
      () => { }
    );
  }

  totalRecords = 0;
  rows = 10;
  searchText = '';
  orderId = '';
  selectedStatus: string = '';
  rangeDates: Date[] | null = null;

  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Completed', value: 'Completed' },
    { label: 'Cancelled', value: 'Cancelled' },
  ];

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  filterChange(event: any) {
    this.selectedStatus = event.status;
    this.searchText = event.search;
    this.orderId = event.orderId;
    this.rangeDates = event.dateRange
    this.table?.reset();
  }
}
